import { WALLET_PROVIDER_KEY } from "@/app/constants/user";
import { HotelRequest } from "@/types";

type FlightLocation = {
  flightId: string;
  from: { name: string; iataCode: string };
  to: { name: string; iataCode: string };
};

export const setLastSearchRequestToLocalStorage = (
  lastSearchRequest: HotelRequest,
  lang: string
) => {
  localStorage.setItem(
    `lastSearchRequest_${lang}`,
    JSON.stringify(lastSearchRequest)
  );
};

export const removeLastSearchRequestToLocalStorage = (lang: string) => {
  localStorage.removeItem(`lastSearchRequest_${lang}`);
};

export const getLastSearchRequestFromLocalStorage = (lang: string) => {
  if (typeof window !== "undefined" && typeof localStorage !== "undefined") {
    let lastSearchRequest = localStorage.getItem(`lastSearchRequest_${lang}`);
    if (!lastSearchRequest) {
      return undefined;
    }
    return JSON.parse(lastSearchRequest);
  }
  return undefined;
};

export const setFlightSearchRequestToLocalStorage = (
  flightSearchRequest: string,
  lang: string
) => {
  localStorage.setItem(`flightLastSearch_${lang}`, flightSearchRequest);
};

export const removeFlightSearchRequestToLocalStorage = (lang: string) => {
  localStorage.removeItem(`flightLastSearch_${lang}`);
};

export const getFlightSearchRequestToLocalStorage = (lang: string) => {
  if (typeof window !== "undefined" && typeof localStorage !== "undefined") {
    let flightSearchRequest = localStorage.getItem(`flightLastSearch_${lang}`);
    if (!flightSearchRequest) {
      return undefined;
    }
    return JSON.parse(flightSearchRequest);
  }
  return undefined;
};

export function setLocationToLocalStorage(
  flightId: string,
  from: any,
  to: any,
  lang: string
) {
  let flights: FlightLocation[] = [];
  const saved = localStorage.getItem(`flightSearchDestinations_${lang}`);
  if (saved) {
    flights = JSON.parse(saved);
  }
  const idx = flights.findIndex((f) => f.flightId === flightId);
  if (idx !== -1) {
    // Replace
    flights[idx] = { flightId, from, to };
  } else {
    // Add
    flights.push({ flightId, from, to });
  }
  localStorage.setItem(
    `flightSearchDestinations_${lang}`,
    JSON.stringify(flights)
  );
}

export function getLocationFromLocalStorage(flightId: string, lang: string) {
  const saved = localStorage.getItem(`flightSearchDestinations_${lang}`);
  if (!saved) return null;
  const flights: FlightLocation[] = JSON.parse(saved);
  return flights.find((f) => f.flightId === flightId) || null;
}
export const setPartnerCode = (partnerCode: string): void =>
  localStorage.setItem("partnerCode", partnerCode);

export const getPartnerCode = (): string => {
  if (typeof window !== "undefined" && typeof localStorage !== "undefined") {
    return localStorage.getItem("partnerCode") ?? "";
  }
  return "";
};

export const getReferredBy = (): string =>
  localStorage.getItem("referredBy") ?? "";

export const setReferredBy = (referredBy: string): void =>
  localStorage.setItem("referredBy", referredBy);

export const getLastBookingSuccessId = (): string | null =>
  localStorage.getItem("last_booking_success") ?? "";

export const getLastCheckoutOfferId = (): string | null =>
  localStorage.getItem("last_checkout_offer_id") ?? "";

export const setLastCheckoutOfferId = (offerId: string): void =>
  localStorage.setItem("last_checkout_offer_id", offerId);

export const setLastBookingSuccessId = (bookingId: string): void =>
  localStorage.setItem("last_booking_success", bookingId);

export const setUtmParams = (utm: string): void =>
  localStorage.setItem("utmParams", utm);

export const getUtmParams = (): string =>
  localStorage.getItem("utmParams") || "{}";

export const addCurrencyToStorage = (currency: string) => {
  localStorage.setItem("currency", currency);
};
export const getCurrencyFromStorage = () => {
  if (typeof window !== "undefined" && typeof localStorage !== "undefined") {
    const currency = localStorage.getItem("currency");
    return currency
      ? JSON.parse(currency)
      : { label: "USD", value: "USD", isDefault: true };
  }
  return { label: "USD", value: "USD", isDefault: true };
};

export const getWalletProviderType = () => {
  if (typeof window !== "undefined" && typeof localStorage !== "undefined") {
    const walletProviderType = localStorage.getItem(WALLET_PROVIDER_KEY);
    if (!walletProviderType) {
      return undefined;
    }
    return walletProviderType;
  }
  return undefined;
};

export const setPartnerParams = (params: string): void =>
  localStorage.setItem("partnerParams", params);

export const getPartnerParams = (): string =>
  localStorage.getItem("partnerParams") || "{}";
